import React, { useState, useRef, useEffect } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';

const T_PREFIX = 'dynamic_matching.freelancer_preferences.truncated_text';

export const TruncatedText = ({ text }: { text: string }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const textElement = textRef.current;
    if (textElement) {
      const checkTruncation = () => {
        if (textElement) {
          setIsTruncated(textElement.scrollHeight > textElement.clientHeight);
        }
      };

      const timeoutId = setTimeout(() => {
        requestAnimationFrame(checkTruncation);
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [text]);

  return (
    <Container direction="row" gap="1" color="bodySecondary">
      <Text
        ref={textRef}
        display="webkitBox"
        overflow="hidden"
        textOverflow="ellipsis"
        webkitBoxOrient="vertical"
        webkitLineClamp={isExpanded ? undefined : 2}
        whiteSpace="preWrap"
      >
        {text}
      </Text>
      {isTruncated && (
        <Text cursor="pointer" decoration="underline" onClick={() => setIsExpanded((prevState) => !prevState)}>
          <I18n k={`${T_PREFIX}.${isExpanded ? 'show_less' : 'read_more'}`} />
        </Text>
      )}
    </Container>
  );
};
